import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import { getPostByCategory } from "../../../redux/postsRedux";
import Posts from "../Posts/Posts";
import { capitalizeFirstLetter } from "../../../utils/capFirstLetter";

const Category = () => {

    const { name } = useParams();
    const postsByCat = useSelector((state) => getPostByCategory(state, name))
    
  return (
    <>
    <h2>Category: { capitalizeFirstLetter(name) }</h2>
    <Posts posts={postsByCat} />
    </>
  );
};

export default Category;
